(function () {
  angular.module('MktzapApp.Controllers')
    .controller('AutoReportController', autoReportController);

  autoReportController.$inject = ['$scope', 'FoundationApi', 'ngTableParams', 'AutoReportService', 'NotificationService', '$rootScope'];

  function autoReportController ($scope, FoundationApi, ngTableParams, AutoReportService, NotificationService, $rootScope) {
    var vm = this;
    vm.script = '';
    vm.edit = edit;
    vm.add = add;
    vm.searchAutoReportTable = searchAutoReportTable;
    vm.saveAutoReport = saveAutoReport;
    vm.titleTypeReport = 'TypeReport';
    vm.titleCompanies = 'Companies';
    vm.totalAutoReport = 0;
    vm.date = null;

    vm.selectToRemove = selectToRemove;
    vm.remove = remove;
    vm.cancelRemove = cancelRemove;

    vm.sendAutoReport = sendAutoReport;

    vm.filters = {
      page: ''
    }

    searchAutoReportTable();

    function searchAutoReportTable () {
      vm.langTable = new ngTableParams({
        count: 50
      }, {
        counts: [25, 50, 100],
        getData: function ($defer, params) {
          var obj = params.url();

          var keys = Object.keys(vm.filters);
          for (var i = 0; i < keys.length; i++) {
            var filterValue = vm.filters[keys[i]];
            if (filterValue != null && filterValue !== '') {
              obj['filter[' + keys[i] + ']'] = filterValue;
            }
          }

          AutoReportService
            .getAutoReports()
            .$promise
            .then(function (data) {
              $defer.resolve(data.autoReports);
              if (data.success) {
                vm.totalAutoReport = data.autoReports.length;
              } else {
                NotificationService.errorHandler(data, 'Erro durante a comunicação com o MongoDB!');
                vm.totalAutoReport = 0;
              }
            })
            .catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao carregar os AutoReports!');
              vm.totalAutoReport = 0;
            });
        }
      });
    }

    function saveAutoReport () {
      try {
        if (vm.script !== '') {
          AutoReportService
            .saveAutoReports(JSON.parse(vm.script))
            .$promise
            .then(function (data) {
              searchAutoReportTable();
              NotificationService.successHandler(data, 'AutoReport salvo com sucesso!');
              FoundationApi.publish('autoReportModal', 'close');
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao salvar AutoReport!');
            })
        } else {
          NotificationService.errorHandler('Nenhum dado informado!', 'Nenhum dado informado!');
        }
      } catch (data) {
        NotificationService.errorHandler(data, 'AutoReport inválido!');
      }
    }

    function add () {
      vm.script = '';
      FoundationApi.publish('autoReportModal', 'open');
      $scope.updateJsonObject();
    }

    function edit (autoReport) {
      vm.script = JSON.stringify(autoReport, null, 2);
      FoundationApi.publish('autoReportModal', 'open');
      $scope.updateJsonObject();
    }

    function selectToRemove (autoReport) {
      FoundationApi.publish('autoReportConfirmationModal', 'open');
      vm.autoReportToRemove = autoReport;
    }

    function remove () {
      if (vm.autoReportToRemove) {
        AutoReportService
          .removeAutoReports(vm.autoReportToRemove)
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, 'AutoReport removido com sucesso!');
            FoundationApi.publish('autoReportConfirmationModal', 'close');
            searchAutoReportTable();
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao salvar AutoReport!');
          })
      } else {
        NotificationService.errorHandler('Nenhum registro selecionado!', 'Nenhum registro selecionado!');
      }
    }

    function cancelRemove () {
      FoundationApi.publish('autoReportConfirmationModal', 'close');
    }

    function sendAutoReport (autoReport) {
      if (vm.date) {
        delete autoReport.days;
        autoReport.cbStartDate = vm.date;
        autoReport.cbEndDate = vm.date;
      }

      obj = { 'autoReport': JSON.stringify(autoReport, null, 2) };

      AutoReportService
        .sendAutoReport(obj)
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Email enviado com sucesso!');
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao enviar Email!');
        })
    }

    $scope.updateJsonObject = function () {
      if (vm.script !== '') {
        try {
          $scope.message = JSON.parse(vm.script);
          $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' };
          vm.jsonValid = true;
        } catch (e) {
          $scope.formatting = { color: 'red', 'background-color': '#f2dede' };
          vm.jsonValid = false;
        }
      } else {
        $scope.formatting = {};
      }
    };
  }
})();
